export const FORM_TITLE = 'Track another order here';
export const KEY_ENTER = 'Enter';
